<template>
  <div class="roster-page">
    <h4 class="mb-2 pb-2 border-bottom pb-2 mt-3">Roster Data</h4>

    <p style="font-size: 15px;">
      View daily and monthly roster reports. Check shifts, attendance, and working hours. Use Roster Tools to optimize rosters and shifts.
    </p>

    <div class="container-fluid px-0 mt-4">
      <div class="mt-4 border rounded">
        <b-tabs
          v-model="activeTab"
          pills
          class="roster-tabs-pills"
          nav-class="roster-nav-pills"
          nav-wrapper-class="roster-nav-wrapper-pills"
          :nav-wrapper-style="{
            background: '#e2f9ff'
          }"
          :nav-style="{
            display: 'flex',
            margin: '0'
          }"
        >
          <b-tab lazy title-link-class="p-0">
            <template #title>
              <span
                :style="tabStyle(0)"
                @mouseenter="hoverTab = 0"
                @mouseleave="hoverTab = null"
              >
                Employees Attendance
              </span>
            </template>

            <div>
              <roster-employees-attendance></roster-employees-attendance>
            </div>
          </b-tab>

          <b-tab lazy title-link-class="p-0">
            <template #title>
              <span
                :style="tabStyle(1)"
                @mouseenter="hoverTab = 1"
                @mouseleave="hoverTab = null"
              >
                Daily Attendance
              </span>
            </template>

            <div>
              <roster-calendar-daily :flag="true"></roster-calendar-daily>
            </div>
          </b-tab>

          <b-tab lazy title-link-class="p-0">
            <template #title>
              <span
                :style="tabStyle(2)"
                @mouseenter="hoverTab = 2"
                @mouseleave="hoverTab = null"
              >
                Monthly Report
              </span>
            </template>

            <div>
              <roster-calendar-monthly></roster-calendar-monthly>
            </div>
          </b-tab>

          <b-tab lazy title-link-class="p-0">
            <template #title>
              <span
                :style="tabStyle(3)"
                @mouseenter="hoverTab = 3"
                @mouseleave="hoverTab = null"
              >
                Roster Tools
              </span>
            </template>

            <roster-employee-data></roster-employee-data>
          </b-tab>

          <b-tab lazy title-link-class="p-0">
            <template #title>
              <span
                :style="tabStyle(4)"
                @mouseenter="hoverTab = 4"
                @mouseleave="hoverTab = null"
              >
                Reporting
              </span>
            </template>

            <roster-reporting></roster-reporting>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      activeTab: 0,
      hoverTab: null
    };
  },

  methods: {
    tabStyle(index) {
      const active = this.activeTab === index;
      const hovered = this.hoverTab === index;

      return {
        display: 'inline-block',
        padding: '10px 18px',
        color: active || hovered ? '#ffffff' : '#787878',
        background: active || hovered ? '#126D66' : 'transparent',
        border: 'none',
        boxShadow: active ? '0 1px 3px rgba(0,0,0,0.08)' : 'none',
        cursor: 'pointer'
      };
    }
  }
};
</script>